export const modalRootCss = {
  zIndex: "100",
};

export const modalContentWrapperCss = {
  height: "100%",
};

export const modalFooterCss = {
  display: "flex",
  alignItems: "center",
  justifyContent: "end",
};

export const textAreaCss = {
  boxSizing: "content-box",
};

export const cancelButtonCss = {
  marginRight: "8px",
};
